import * as React from 'react';
import Popover from '@mui/material/Popover';
import { ThemeProvider, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { GridOn } from '@mui/icons-material';
import { Alert, Box, IconButton, Snackbar, Stack, Tooltip } from '@mui/material';
import Service from '../../../util/Service';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));
const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export default function TablePopover(props) {
    const { onSelect, code, refDiv, refreshEditor, element } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [linha, setLinha] = React.useState(0);
    const [coluna, setColuna] = React.useState(0);
    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);
    const [clonedContent, setClonedContent] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            const s = window.getSelection();
            if (s.rangeCount === 0) {
                handleClose();
                return;
            }
            const range = s.getRangeAt(0);//s.baseNode;
            const cc = range.startContainer;//.cloneContents(); //extractContents();            
            setClonedContent(cc);
        }
    }, [open]);

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const BoxSx = (props) => {
        const{row, col} = props
        function isIn(){
            if( row <= linha-1 && col <= coluna-1) return 'primary.select';
            return ;
        }
        return (
            <ThemeProvider
                theme={{
                    palette: {
                        primary: {
                            main: '#007FFF',
                            dark: '#0066CC',
                            select: 'lightblue',
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        width : 16,
                        height: 16,
                        // borderRadius: 1,
                        // border: '2px solic #007FFF',
                        border: '1px solid',
                        borderColor: 'primary.main',
                        bgcolor: isIn(),
                        '&:hover': {
                            bgcolor: 'primary.dark',
                        },
                    }}
                    onMouseEnter={() => handleMouseHover(row, col)}
                    onMouseLeave={() => handleMouseHover(0, 0)}
                    onClick={handleSelecionado}
                >                    
                </Box>
            </ThemeProvider>
        );
    }
    const handleSelecionado=()=>{
        console.log( linha, coluna);
        console.log('>>>handleTabelaEscala<<');
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        clonedContent.replaceWith(remove);
        const htmlOld = refDiv.current.innerHTML;
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }

        const dado = {
            code: html,
            linha: linha, 
            coluna: coluna
        }
        Service.POST("/api/security/model/tabelaBasica", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();                        
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const handleMouseHover=(l, c)=>{
        setLinha(l+1);
        setColuna(c+1);
    }
    return (
        <React.Fragment>
            <Tooltip title="Tabela básica">
                <IB
                    color={'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <GridOn />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}                
            >
                <Box sx={{ p: 1 }}>
                {numbers.map((n, id) => (
                    <Stack key={id}>
                        <Stack  direction="row">
                            {numbers.map((n, idd) => (
                                <BoxSx key={id + "-" + idd} row={id} col={idd}/>
                            ))}
                        </Stack>

                    </Stack>
                ))}
                </Box>
                <Typography align='center' sx={{ p: 2 }}>{linha+" - "+coluna}</Typography>
            </Popover>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
